import client from "./client";

export interface AuditLogEntry {
  id: string;
  user_id: string | null;
  user_name: string | null;
  user_email: string | null;
  action: string;
  entity_type: string;
  entity_id: string | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  ip_address: string | null;
  created_at: string | null;
}

export interface AuditLogPage {
  items: AuditLogEntry[];
  next_before: string | null;
  has_more: boolean;
}

export interface AuditLogFilters {
  action?: string;
  entity_type?: string;
  entity_id?: string;
  user_id?: string;
  since?: string;
  before?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
}

export async function listAuditLogs(
  filters: AuditLogFilters = {},
): Promise<AuditLogPage> {
  const { data } = await client.get("/audit-logs", { params: filters });
  return data;
}

export async function listAuditActions(): Promise<string[]> {
  const { data } = await client.get("/audit-logs/actions");
  return data.actions ?? [];
}

export async function exportAuditLogs(
  filters: Omit<AuditLogFilters, "before" | "since" | "limit"> = {},
): Promise<{ blob: Blob; filename: string }> {
  const response = await client.get("/audit-logs/export", {
    params: filters,
    responseType: "blob",
  });
  const disp =
    (response.headers as Record<string, string> | undefined)?.[
      "content-disposition"
    ] ?? "";
  const m = /filename="?([^"]+)"?/.exec(disp);
  return {
    blob: response.data,
    filename: m ? m[1] : "audit-log.csv",
  };
}
